import barba from '@barba/core';
import { gsap, Quart } from 'gsap';

import Config from './Config';

export default class {
  constructor() {
    const pack = Config.getInstance();

    barba.init({
      sync: true,
      transitions: [
        {
          before() {
            // ページ遷移の始まり
            trace('before');
          },
          beforeLeave() {
            // ページ遷移の前
            trace('beforeLeave');
          },
          async leave({ current, next, trigger }) {
            // 現在のページの離脱
            trace('leave');
            const done = this.async();
            await pack.common.startLeaveTransition();
            done(); // ページ遷移を実行
          },
          afterLeave() {
            // 現在のページの離脱後 (次ページコンテナがある状態)
            trace('afterLeave');
          },
          beforeEnter() {
            // 次ページに入る前
            trace('beforeEnter');
          },
          enter({ current, next, trigger }) {
            // 次ページに入った時
            trace('enter');
            pack.common.startEnterTransition();
          },

          afterEnter() {
            // 次ページに入った後
            trace('afterEnter');
          },
          after() {
            // すべて完了
            trace('after');
          },
        },
      ],
    });
  }
}
